import { LOAN_SENIORITY_TYPES } from "@loanbossinc/component-library";

export const sortLoansBySeniority = loans => sortBySeniority(loans);
const sortBySeniority = loans => {
  if (loans && loans.length > 0) {
    const sortedLoans = [];
    const lienPriorities = new Set();
    loans.forEach(x => lienPriorities.add(x.lienPriority));
    const iterableLienPriorities = [...lienPriorities].sort();

    for (let index = 0; index < iterableLienPriorities.length; index++) {
      const priority = iterableLienPriorities[index];
      const filtered = loans.filter(x => x.lienPriority === priority);
      const sortedArray = addToSortedLoans(filtered);
      sortedLoans.push(...sortedArray);
    }

    return sortedLoans;
  }
};

const addToSortedLoans = loans => {
  const sortedLoans = [];
  const filteredSenior = loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SENIOR);
  const filteredSubordinate = loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUBORDINATE);
  const filteredSubsidy = loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUBSIDY);
  const filteredSupplemental = loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUPPLEMENTAL);

  if (filteredSenior.length > 0) {
    sortedLoans.push(...filteredSenior.sort((a, b) => a.id - b.id).sort((a, b) => new Date(a.closingDate) - new Date(b.closingDate)));
  }
  if (filteredSubordinate.length > 0) {
    sortedLoans.push(...filteredSubordinate.sort((a, b) => a.id - b.id).sort((a, b) => new Date(b.closingDate) - new Date(a.closingDate)));
  }
  if (filteredSubsidy.length > 0) {
    sortedLoans.push(...filteredSubsidy.sort((a, b) => a.id - b.id).sort((a, b) => new Date(b.closingDate) - new Date(a.closingDate)));
  }
  if (filteredSupplemental.length > 0) {
    sortedLoans.push(...filteredSupplemental.sort((a, b) => a.id - b.id).sort((a, b) => new Date(b.closingDate) - new Date(a.closingDate)));
  }

  return sortedLoans;
};

export const findDistinctLendersByLoans = (loans, maxLenders) => findDistinctLenders(loans, maxLenders);
const findDistinctLenders = (loans, maxLenders) => {
  if (loans && loans.length > 0) {
    const distinctList = loans.reduce((accum, cur) => {
      if (!cur || !cur.loanProvider || cur.loanProvider.length === 0 || !cur.lenderCompany) {
        return accum;
      }
      if (!accum.some(item => item.lenderCompany.id === cur.lenderCompany.id)) {
        accum.push(cur);
      }

      return accum;
    }, []).slice(0, maxLenders);

    return distinctList.reduce((accum, cur) => {
      if (!cur && cur.loanProvider && cur.loanProvider.length) {
        return accum;
      }
      accum.push({
        lenderName: cur.loanProvider[0].name,
        logo: cur.loanProvider[0].logoImage,
        id: cur.loanProvider[0].id,
        loanSeniority: cur.loanSeniority ? cur.loanSeniority.value : "",
        closingDate: cur.closingDate,
        currentBalance: cur.currentPrincipalBalance,
        maturityDate: cur.maturityDate,
        prepaymentPenalty: cur.prepaymentPenalty,
        isLockout: cur.isLockout
      });

      return accum;
    }, []);
  }
};

